/**
 * 后台认得的模型能力。
 *
 * 这份清单原来在六个文件里各抄了一遍，加 embedding 时漏一处就是「这个页签上看不见向量」。
 * 服务端的对应口径在 assembly/model-capabilities/registry.js 的 MODEL_ADAPTERS。
 */
export const MODEL_CAPABILITIES = ['text', 'image', 'video', 'tts', 'embedding']

/**
 * 会向玩家计费的能力。成本看板只认这些：它按 billing_mode 分组、按 charged_points 求和，
 * 而向量调用没有 billing 端口，embedding_call_log 根本没有这两列。
 * 向量的供应商成本仍然逐条记着，在调用记录里看。
 */
export const BILLED_CAPABILITIES = ['text', 'image', 'video', 'tts']
